import { METRICS_DATA } from '~/modules/dashboard/constants/mock-data';

import { ICampaignMetricKey } from '~/modules/campaign-analytics/types';
import { CardAnalyticBarChart } from '~/modules/campaign-analytics';
import { EAnalyticMode } from '~/modules/analytics/types';
import { Grid } from '@shopify/polaris';

const CHART_CONFIGS: {
  metricKey: ICampaignMetricKey;
  label: string;
}[] = [
  {
    label: 'Visitors by type',
    metricKey: ICampaignMetricKey.VISITOR_BY_TYPE,
  },
  {
    label: 'Sessions by device type',
    metricKey: ICampaignMetricKey.SESSIONS_BY_DEVICE_TYPE,
  },
  {
    label: 'Sessions by traffic source',
    metricKey: ICampaignMetricKey.SESSIONS_BY_TRAFFIC_SOURCE,
  },
];

export const TrafficBreakdown = () => {
  return (
    <Grid>
      {CHART_CONFIGS.map((config, index) => (
        <Grid.Cell columnSpan={{ xs: 6, lg: 4 }} key={index}>
          <CardAnalyticBarChart
            metricKey={config.metricKey}
            label={config.label}
            metrics={METRICS_DATA}
            isLoading={false}
            isEmptyMetricData={false}
            analyticMode={EAnalyticMode.ALL_SESSION}
            barChartProps={{
              xAxisOptions: { hide: false },
            }}
          />
        </Grid.Cell>
      ))}
    </Grid>
  );
};
